/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { BiddingItem } from 'store/modules/contract_analysis/types';
import { ContractValidationPayload } from 'services/actions/contract_validations';
import UploadCard from 'components/molecules/upload_card';
import { Container } from './styles';

interface ContractAnalysisFormProps {
  bidding: BiddingItem | null;
  biddingLoading?: boolean;
  onSearchBidding?: (biddingId: number) => void;
  submitting: boolean;
  onSubmit: (payload: ContractValidationPayload) => void;
}

const ContractAnalysisForm: React.FC<ContractAnalysisFormProps> = ({
  bidding,
  biddingLoading = false,
  onSearchBidding,
  submitting,
  onSubmit,
}) => {
  const fixed = !onSearchBidding;
  const [biddingId, setBiddingId] = useState(fixed && bidding ? String(bidding.id) : '');
  const [editalFile, setEditalFile] = useState<File | null>(null);
  const [contractFile, setContractFile] = useState<File | null>(null);
  const [organization, setOrganization] = useState('');
  const [numeroEdital, setNumeroEdital] = useState('');
  const [modality, setModality] = useState('');
  const [law, setLaw] = useState('');
  const [lockedBySearch, setLockedBySearch] = useState(false);

  useEffect(() => {
    setOrganization(bidding?.orgao_nome || '');
    setNumeroEdital(bidding?.edital || '');
    setModality(bidding?.modalidade || '');
    setLockedBySearch(!!bidding);
  }, [bidding]);

  useEffect(() => {
    if (fixed) return;

    setOrganization('');
    setNumeroEdital('');
    setModality('');
    setLockedBySearch(false);
  }, [biddingId]);

  const handleSearch = () => {
    if (biddingId && biddingId.length < 6) return;

    onSearchBidding?.(Number(biddingId));
  };

  const handleSubmit = () => {
    if (submitting) return;

    if (!editalFile || !contractFile) {
      alert('Envie os dois documentos.');
      return;
    }

    onSubmit({
      modality,
      organization,
      bidding_number: numeroEdital,
      bidding_id: biddingId || undefined,
      law: law || undefined,
      edital: editalFile,
      contract: contractFile,
    });
  };

  return (
    <Container>
      <div className="card border rounded p-4 mb-4">
        <h5 className="mb-4">
          {fixed ? 'Licitação vinculada' : 'Como deseja vincular a licitação?'}
        </h5>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Nº Conlicitação</label>

            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Digite os 8 dígitos"
                maxLength={8}
                value={biddingId}
                onChange={(e) => setBiddingId(e.target.value.replace(/\D/g, ''))}
                disabled={fixed}
              />

              {!fixed && (
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center"
                    onClick={handleSearch}
                    disabled={biddingLoading || biddingId.length < 6}
                  >
                    {biddingLoading ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      <i className="material-icons">search</i>
                    )}
                  </button>
                </div>
              )}
            </div>

            {!fixed && (
              <small className="form-text text-muted">
                O Nº Conlicitação deve conter 8 dígitos.
              </small>
            )}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Órgão</label>
            <input
              type="text"
              className="form-control"
              value={organization}
              placeholder="Ex. Ministério da Infraestrutura"
              onChange={(e) => setOrganization(e.target.value)}
              disabled={lockedBySearch}
            />
          </div>

          <div className="form-group col-md-6">
            <label>Número do Edital</label>
            <input
              type="text"
              className="form-control"
              value={numeroEdital}
              placeholder="Ex. 045/2025"
              onChange={(e) => setNumeroEdital(e.target.value)}
              disabled={lockedBySearch}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Modalidade</label>
            <input
              type="text"
              className="form-control"
              value={modality}
              placeholder="Ex. Pregão Eletrônico"
              onChange={(e) => setModality(e.target.value)}
              disabled={lockedBySearch}
            />
          </div>
          <div className="form-group col-md-6">
            <label>A licitação é regida pela lei:</label>

            <select className="form-control" value={law} onChange={(e) => setLaw(e.target.value)}>
              <option value="">Selecionar lei</option>
              <option value="14133">Lei 14.133/2021</option>
              <option value="13303">Lei 13.303/2016</option>
            </select>
          </div>
        </div>
      </div>
      <UploadCard
        title="Upload dos Documentos do Edital"
        onFileSelect={(file) => setEditalFile(file)}
      />

      <UploadCard
        title="Upload do Contrato Recebido"
        onFileSelect={(file) => setContractFile(file)}
      />
      <div className="d-flex justify-content-end mt-4">
        <button
          type="button"
          className="btn btn-primary d-flex align-items-center mr-5"
          onClick={handleSubmit}
          disabled={!editalFile || !contractFile || submitting}
        >
          {submitting ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" />
              Enviando...
            </>
          ) : (
            'Enviar para Análise'
          )}
        </button>
      </div>
    </Container>
  );
};

export default ContractAnalysisForm;
